<template>

  <modalo
    :title="stage.name"
    type="mini"
    @hideModal="hideModal()"
    :modaloWatch="() => stage">

    <form id="stage-form" v-on:submit.prevent="saveStage(stage)">
      <div class="form-group">
        <label>{{ $t('Name') }}</label>
        <input v-autofocus type="text" class="form-control" v-model="stage.name">
        <ValidateMessage :error="validateErrors.name" />
      </div>
      <div class="form-check">
        <input type="checkbox" class="form-check-input" v-model="stage.default">
        <label class="form-check-label">{{ $t('Default') }}</label>
        <ValidateMessage :error="validateErrors.default" />
      </div>

      <div class="form-group">
        <label>{{ $t('Type') }}</label>
        <select class="form-control" v-model="stage.type">
          <option value="phone-screen">Contato por telefone</option>
          <option value="shortlist">Shortlist</option>
          <option value="interview">Entrevista</option>
          <option value="offer">Oferta</option>
          <option value="hired">Contratado</option>
        </select>
        <ValidateMessage :error="validateErrors.type" />
      </div>
      
      <div class="form-group">
        <label>{{ $t('Active') }}</label>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="1" v-model="stage.active">
          <label class="form-check-label">
            {{ $t('Active') }}
          </label>
        </div>
        <ValidateMessage :error="validateErrors.active" />
      </div>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="stage-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <!--<button
            type="button"
            class="btn btn-danger"
            @click="deleteStage(stage._id)">{{ $t('Delete') }}</button>-->
      </div>
    </template>

  </modalo>

</template>

<script>
import StageActionForm from './StageActionForm'

export default {
  name: 'StageForm',
  components: {
    StageActionForm
  },
  props: [
    'initStage'
  ],
  data () {
    return {
      loading: false,
      stage: this.defaultValues(this.initStage),
      validateErrors: {}
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveStage
    */
    saveStage (data) {
      if (data._id) this.updateStage(data._id, data)
      else this.createStage(data)
    },
    /*
    createStage
    */
    createStage (data) {
      this.loading = true

      this.$store
      .dispatch('createStage', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateStage
    */
    updateStage (id, data) {
      this.loading = true

      this.$store
      .dispatch('updateStage', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteStage (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteStage', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Stage/StageForm.vue